import React, { useState, useEffect } from 'react';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import { offerService } from '../services/offerService';
import { couponService } from '../services/couponService';
import { companyService } from '../services/companyService';
import { imagesAPI } from '../services/imageService';
import { employeeService } from '../services/employeeService'; // 🆕 AJOUTER CETTE LIGNE
import './Offers.css';

// 🌈 CATEGORIES D'OFFRES (existant)
const OFFER_CATEGORIES = [
  { id: 'financial', name: 'Support financier', icon: '💰', color: '#4ecdc4' },
  { id: 'family', name: 'Famille & éducation', icon: '👨‍👩‍👧‍👦', color: '#ff9f43' },
  { id: 'shopping', name: 'Achats courants', icon: '🛍️', color: '#a29bfe' },
  { id: 'leisure', name: 'Voyages & loisirs', icon: '🌴', color: '#1dd1a1' },
  { id: 'health', name: 'Santé', icon: '🏥', color: '#48dbfb' },
  { id: 'food', name: 'Restauration', icon: '🍽️', color: '#ff6b6b' },
  { id: 'religious', name: 'Vie spirituelle', icon: '🕋', color: '#6c5ce7' },
  { id: 'wellness', name: 'Sport & bien-être', icon: '🧘', color: '#feca57' },
  { id: 'training', name: 'Formation pro', icon: '💼', color: '#10ac84' },
  { id: 'culture', name: 'Culture', icon: '🎭', color: '#ee5253' },
];

// 🎯 TYPES D'OFFRES (existant)
const OFFER_TYPES = [
  { id:'discount',     name:'Réduction',     icon:'🏷️', color:'#667eea' },
  { id:'voucher',      name:'Bon / Coupon',  icon:'🧾', color:'#feca57' },
  { id:'cash_support', name:'Prise en charge',icon:'🏛️', color:'#00b894' },
  { id:'credit',       name:'Crédit / Paiement', icon:'💳', color:'#54a0ff' },
  { id:'gift',         name:'Cadeau',        icon:'🎁', color:'#ff9ff3' },
  { id:'access',       name:'Accès VIP',     icon:'🔑', color:'#5f27cd' },
  { id:'event',        name:'Événement',     icon:'🎟️', color:'#48dbfb' },
  { id:'logistics',    name:'Livraison / Promo', icon:'🚚', color:'#96ceb4' },
];

// 🔧 CONFIGURATION DES ACTIONS PAR TYPE (existant)
const OFFER_SYSTEMS_CONFIG = {
  voucher: { hasCoupons: true },
  access: { hasCoupons: true },
  gift: { hasCoupons: true },
  discount: { hasCoupons: false },
  logistics: { hasCoupons: false },
  event: { hasCoupons: false },
  cash_support: { hasCoupons: false },
  credit: { hasCoupons: false }
};

// ==================== 🎫 COMPOSANTS EXISTANTS ====================

// 🎫 Composant pour afficher les statistiques réelles des coupons (EXISTANT)
const CouponStats = ({ offerId }) => {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        setLoading(true);
        const couponsData = await couponService.getAdminCoupons(offerId);
        setCoupons(couponsData.data || couponsData || []);
      } catch (err) {
        setError('Erreur lors du chargement des coupons');
        console.error('Erreur fetch coupons:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCoupons();
  }, [offerId]);

  const stats = {
    total: coupons.length,
    used: coupons.filter(c => c.status === 'used').length,
    active: coupons.filter(c => c.status === 'active').length,
    expired: coupons.filter(c => c.status === 'expired').length
  };

  if (loading) {
    return (
      <div className="detail-item">
        <label>Chargement des statistiques...</label>
        <span>⏳</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="detail-item full-width">
        <label>Erreur:</label>
        <span className="error-text">{error}</span>
      </div>
    );
  }

  return (
    <>
      <div className="detail-item">
        <label>Coupons totaux:</label>
        <span>{stats.total}</span>
      </div>
      <div className="detail-item">
        <label>Coupons utilisés:</label>
        <span>{stats.used}</span>
      </div>
      <div className="detail-item">
        <label>Coupons disponibles:</label>
        <span className="available-highlight">{stats.active}</span>
      </div>
      <div className="detail-item">
        <label>Coupons expirés:</label>
        <span>{stats.expired}</span>
      </div>
      <div className="detail-item">
        <label>Taux d'utilisation:</label>
        <span>
          {stats.total > 0 ? Math.round((stats.used / stats.total) * 100) : 0}%
        </span>
      </div>
    </>
  );
};

// 🎨 Composant Modal pour les détails (EXISTANT - MODIFIÉ)
const OfferDetailsModal = ({ offer, onClose }) => {
  if (!offer) return null;

  const categoryInfo = OFFER_CATEGORIES.find(cat => cat.id === offer.category) || OFFER_CATEGORIES[0];
  const typeInfo = OFFER_TYPES.find(type => type.id === offer.type) || OFFER_TYPES[0];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Détails de l'offre</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          {offer.imageUrl && (
            <div className="offer-image-section">
              <div className="offer-image-container">
                <img 
                  src={offer.imageUrl} 
                  alt={offer.title}
                  className="offer-detail-image"
                />
              </div>
            </div>
          )}



          <div className="details-section">
            <h3>Informations principales</h3>
            <div className="details-grid">
              <div className="detail-item">
                <label>Titre:</label>
                <span>{offer.title}</span>
              </div>
              <div className="detail-item">
                <label>Code offre:</label>
                <span className="code-value">{offer.codeOffre}</span>
              </div>
              <div className="detail-item">
                <label>Catégorie:</label>
                <span>
                  <span className="category-icon">{categoryInfo.icon}</span>
                  {categoryInfo.name}
                </span>
              </div>
              <div className="detail-item">
                <label>Type:</label>
                <span>
                  <span className="type-icon">{typeInfo.icon}</span>
                  {typeInfo.name}
                </span>
              </div>
              {offer.discount && (
                <div className="detail-item">
                  <label>Avantage:</label>
                  <span className="discount-highlight">{offer.discount}</span>
                </div>
              )}
              <div className="detail-item">
                <label>Statut:</label>
                <span className={`status ${offer.isActive ? 'active' : 'inactive'}`}>
                  {offer.isActive ? '🟢 Active' : '🔴 Inactive'}
                </span>
              </div>
              <div className="detail-item">
                <label>Exclusive:</label>
                <span>{offer.isExclusive ? '👑 Oui' : '🌍 Non'}</span>
              </div>
              
                {offer.isExclusive && (
                <div className="detail-item">
                  <label>Exclusivité employé:</label>
                  <span>
                    {offer.isEmployeeExclusive ? '👤 Spécifique' : '🏢 Toute l\'entreprise'}
                  </span>
                </div>
              )}
              
            </div>
          </div>
          
          
          {offer.isExclusive && offer.forCompanies && offer.forCompanies.length > 0 && (
            <div className="details-section">
              <h3>Entreprises autorisées ({offer.forCompanies.length})</h3>
              <div className="companies-list">
                {Array.isArray(offer.forCompanies) 
                  ? offer.forCompanies.map((companyId, index) => (
                      <div key={index} className="company-tag">
                        <code>{companyId}</code>
                      </div>
                    ))
                  : <span>Aucune entreprise spécifiée</span>
                }
              </div>
            </div>
          )}

          {/* 🆕 AJOUTER SECTION EMPLOYÉS SPÉCIFIQUES */}
          {offer.isEmployeeExclusive && offer.forEmployees && offer.forEmployees.length > 0 && (
            <div className="details-section">
              <h3>Employés spécifiques ({offer.forEmployees.length})</h3>
              <div className="companies-list">
                {Array.isArray(offer.forEmployees) 
                  ? offer.forEmployees.map((employeeId, index) => (
                      <div key={index} className="company-tag">
                        <code>{employeeId}</code>
                      </div>
                    ))
                  : <span>Aucun employé spécifié</span>
                }
              </div>
            </div>
          )}


          {/* 🔥 AJOUT: Informations du partenaire détaillées */}
          <div className="details-section">
            <h3>Partenaire</h3>
            <div className="details-grid">
              <div className="detail-item">
                <label>Nom du partenaire:</label>
                <span>{offer.partnerName}</span>
              </div>
              <div className="detail-item">
                <label>ID Partenaire:</label>
                <span className="code-value">{offer.partnerId}</span>
              </div>
            </div>
          </div>

          {/* Reste du contenu existant... */}
          <div className="details-section">
            <h3>Description</h3>
            <p className="full-description">{offer.description}</p>
          </div>

          {/* Entreprises autorisées */}
          {offer.isExclusive && offer.forCompanies && offer.forCompanies.length > 0 && (
            <div className="details-section">
              <h3>Entreprises autorisées ({offer.forCompanies.length})</h3>
              <div className="companies-list">
                {Array.isArray(offer.forCompanies) 
                  ? offer.forCompanies.map((companyId, index) => (
                      <div key={index} className="company-tag">
                        <code>{companyId}</code>
                      </div>
                    ))
                  : <span>Aucune entreprise spécifiée</span>
                }
              </div>
            </div>
          )}

          {/* Gestion des coupons */}
          {offer.hasCoupons && (
            <div className="details-section">
              <h3>Gestion des coupons</h3>
              <div className="details-grid">
                <div className="detail-item">
                  <label>Système de coupons:</label>
                  <span>{offer.hasCoupons ? '🎫 Activé' : '🚫 Désactivé'}</span>
                </div>
                <CouponStats offerId={offer._id} />
              </div>
            </div>
          )}

          {/* Contribution employeur */}
          {(offer.employerContribution > 0 || offer.maxAmount > 0) && (
            <div className="details-section">
              <h3>Contribution employeur</h3>
              <div className="details-grid">
                {offer.employerContribution > 0 && (
                  <div className="detail-item">
                    <label>Contribution:</label>
                    <span>{offer.employerContribution}%</span>
                  </div>
                )}
                {offer.maxAmount > 0 && (
                  <div className="detail-item">
                    <label>Montant maximum:</label>
                    <span>{offer.maxAmount} DA</span>
                  </div>
                )}
                {offer.maxDuration > 0 && (
                  <div className="detail-item">
                    <label>Durée maximum:</label>
                    <span>{offer.maxDuration} mois</span>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Localisation */}
          {offer.hasAddress && (
            <div className="details-section">
              <h3>Localisation</h3>
              <div className="details-grid">
                <div className="detail-item full-width">
                  <label>Adresse:</label>
                  <span>{offer.address}</span>
                </div>
                {offer.geolocalisation && (
                  <div className="detail-item full-width">
                    <label>Localisation:</label>
                    <Button 
                      variant="primary" 
                      size="sm"
                      onClick={() => {
                        const coords = offer.geolocalisation.replace("geo:", ""); 
                        window.open(`https://www.google.com/maps?q=${coords}`, '_blank');
                      }}
                    >
                      📍 Voir sur Google Maps
                    </Button>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Conditions d'utilisation */}
          {offer.conditions && offer.conditions.length > 0 && (
            <div className="details-section">
              <h3>Conditions d'utilisation</h3>
              <ul className="conditions-list">
                {offer.conditions.map((condition, index) => (
                  <li key={index}>{condition}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Instructions d'utilisation */}
          {offer.usageInstructions && offer.usageInstructions.length > 0 && (
            <div className="details-section">
              <h3>Instructions d'utilisation</h3>
              <ul className="instructions-list">
                {offer.usageInstructions.map((instruction, index) => (
                  <li key={index}>{instruction}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Dates et métadonnées */}
          <div className="details-section">
            <h3>Dates et métadonnées</h3>
            <div className="details-grid">
              <div className="detail-item">
                <label>Date de début:</label>
                <span>{new Date(offer.startDate).toLocaleDateString('fr-FR')}</span>
              </div>
              <div className="detail-item">
                <label>Date de fin:</label>
                <span>{new Date(offer.endDate).toLocaleDateString('fr-FR')}</span>
              </div>
              <div className="detail-item">
                <label>Créée le:</label>
                <span>{new Date(offer.createdAt).toLocaleDateString('fr-FR')}</span>
              </div>
              <div className="detail-item">
                <label>Modifiée le:</label>
                <span>{new Date(offer.updatedAt).toLocaleDateString('fr-FR')}</span>
              </div>
              <div className="detail-item">
                <label>Note utilisateurs:</label>
                <span>⭐ {offer.userRating}/5</span>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <Button variant="secondary" onClick={onClose}>
            Fermer
          </Button>
        </div>
      </div>
    </div>
  );
};

// 🎫 Composant Modal pour les coupons (EXISTANT)
const CouponsModal = ({ offer, coupons, onClose }) => {
  if (!offer) return null;

  const couponsList = Array.isArray(coupons) ? coupons : [];
  const stats = {
    total: couponsList.length,
    active: couponsList.filter(c => c.status === 'active').length,
    used: couponsList.filter(c => c.status === 'used').length,
    expired: couponsList.filter(c => c.status === 'expired').length
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>🎫 Gestion des coupons</h2>
          <div className="modal-subtitle">{offer.title}</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          <div className="coupons-stats">
            <div className="stat-item">
              <div className="stat-number total">{stats.total}</div>
              <div className="stat-label">Total générés</div>
            </div>
            <div className="stat-item">
              <div className="stat-number active">{stats.active}</div>
              <div className="stat-label">Disponibles</div>
            </div>
            <div className="stat-item">
              <div className="stat-number used">{stats.used}</div>
              <div className="stat-label">Utilisés</div>
            </div>
            <div className="stat-item">
              <div className="stat-number expired">{stats.expired}</div>
              <div className="stat-label">Expirés</div>
            </div>
          </div>

          <div className="coupons-list">
            <h3>Détail des coupons</h3>
            
            {couponsList.length === 0 ? (
              <div className="empty-coupons">
                <div className="empty-icon">🎫</div>
                <p>Aucun coupon généré pour cette offre</p>
                <small>Les coupons sont créés automatiquement quand l'offre est activée</small>
              </div>
            ) : (
              <div className="coupons-table">
                <div className="table-header">
                  <div className="col-code">Code coupon</div>
                  <div className="col-status">Statut</div>
                  <div className="col-user">Utilisateur</div>
                  <div className="col-date">Date utilisation</div>
                  <div className="col-expiry">Expiration</div>
                </div>
                
                <div className="table-body">
                  {couponsList.map((coupon) => (
                    <div key={coupon._id} className={`table-row ${coupon.status}`}>
                      <div className="col-code">
                        <span className="coupon-code">{coupon.code}</span>
                      </div>
                      <div className="col-status">
                        <span className={`status-badge ${coupon.status}`}>
                          {coupon.status === 'active' && '🟢 Actif'}
                          {coupon.status === 'used' && '✅ Utilisé'}
                          {coupon.status === 'expired' && '🔴 Expiré'}
                        </span>
                      </div>
                      <div className="col-user">
                        {coupon.userId ? (
                          <span className="user-info">
                            {coupon.user?.firstName || 'Utilisateur'} {coupon.user?.lastName || ''}
                            <br />
                            <small>{coupon.user?.employeeId || coupon.userId}</small>
                          </span>
                        ) : (
                          <span className="not-assigned">Non attribué</span>
                        )}
                      </div>
                      <div className="col-date">
                        {coupon.usedAt 
                          ? new Date(coupon.usedAt).toLocaleDateString('fr-FR')
                          : '-'
                        }
                      </div>
                      <div className="col-expiry">
                        {new Date(coupon.expiresAt).toLocaleDateString('fr-FR')}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <Button variant="primary" onClick={onClose}>
            Fermer
          </Button>
        </div>
      </div>
    </div>
  );
};

// ==================== 🆕 MODALS AJOUTÉES ====================

// ✏️ Modal pour créer/modifier une offre
const OfferFormModal = ({ offer, partners = [], onSave, onClose }) => {
  const isEditing = !!offer;
  
  const [companies, setCompanies] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState('');
  const [selectedEmployeeId, setSelectedEmployeeId] = useState('');
  const [loadingEmployees, setLoadingEmployees] = useState(false);

  // État du formulaire
  const [formData, setFormData] = useState(isEditing ? {
    title: offer.title || '',
    codeOffre: offer.codeOffre || '',
    description: offer.description || '',
    category: offer.category || 'shopping',
    type: offer.type || 'discount',
    discount: offer.discount || '',
    partnerId: offer.partnerId || '',
    partnerName: offer.partnerName || '',
    isExclusive: offer.isExclusive || false,
    isEmployeeExclusive: offer.isEmployeeExclusive || false, // 🆕 NOUVEAU CHAMP
    forCompanies: Array.isArray(offer.forCompanies) ? offer.forCompanies : [], // 🆕 Tableau, pas string
    forEmployees: Array.isArray(offer.forEmployees) ? offer.forEmployees : [], // 🆕 Tableau, pas string
    startDate: offer.startDate ? new Date(offer.startDate).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
    endDate: offer.endDate ? new Date(offer.endDate).toISOString().split('T')[0] : new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    hasCoupons: offer.hasCoupons || false,
    totalCoupons: offer.totalCoupons || 0,
    conditions: Array.isArray(offer.conditions) ? offer.conditions.join('\n') : '',
    usageInstructions: Array.isArray(offer.usageInstructions) ? offer.usageInstructions.join('\n') : '',
    hasAddress: offer.hasAddress || false,
    address: offer.address || '',
    geolocalisation: offer.geolocalisation || '',
    isActive: offer.isActive !== undefined ? offer.isActive : true,
    redirectUrl: offer.redirectUrl || '',
    employerContribution: offer.employerContribution || 0,
    maxAmount: offer.maxAmount || '',
    maxDuration: offer.maxDuration || '',
    imageUrl: offer.imageUrl || ''
  } : {
    title: '',
    codeOffre: '',
    description: '',
    category: 'shopping',
    type: 'discount',
    discount: '',
    partnerId: '',
    partnerName: '',
    isExclusive: false,
    isEmployeeExclusive: false, // 🆕 NOUVEAU CHAMP
    forCompanies: [], // 🆕 Tableau vide
    forEmployees: [], // 🆕 Tableau vide
    startDate: new Date().toISOString().split('T')[0],
    endDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    hasCoupons: false,
    totalCoupons: 0,
    conditions: '',
    usageInstructions: '',
    hasAddress: false,
    address: '',
    geolocalisation: '',
    isActive: true,
    redirectUrl: '',
    employerContribution: 0,
    maxAmount: '',
    maxDuration: '',
    imageUrl: ''
  });


  // 🆕 AJOUTER CE useEffect POUR CHARGER LES EMPLOYÉS
useEffect(() => {
  const loadEmployeesForCompany = async () => {
    if (!selectedCompanyId) {
      setEmployees([]);
      return;
    }
    
    try {
      setLoadingEmployees(true);
      const employeesData = await employeeService.getEmployees();
      
      // Filtrer les employés par entreprise côté client
      const allEmployees = employeesData.employees || employeesData || [];
      console.log('Tous les employés chargés:', allEmployees); // 🆕 DEBUG
      const filteredEmployees = allEmployees.filter(emp => {
        // Vérifier selon la structure de vos données
        return emp.companyId === selectedCompanyId || 
               emp.company === selectedCompanyId ||
               emp.companyId?._id === selectedCompanyId;
      });
      
      setEmployees(filteredEmployees);
    } catch (error) {
      console.error('Erreur chargement employés:', error);
      setEmployees([]);
    } finally {
      setLoadingEmployees(false);
    }
  };
  
  loadEmployeesForCompany();
}, [selectedCompanyId]);



  // 🆕 AJOUTER CE useEffect POUR CHARGER LES ENTREPRISES
useEffect(() => {
  const loadCompanies = async () => {
    try {
      const response = await companyService.getCompanies();
      
      // 🆕 GESTION DES DIFFÉRENTS FORMATS DE RÉPONSE
      let companiesData = [];
      
      if (Array.isArray(response)) {
        // Cas 1: response est directement un tableau
        companiesData = response;
      } else if (response && Array.isArray(response.data)) {
        // Cas 2: response.data est un tableau
        companiesData = response.data;
      } else if (response && response.companies && Array.isArray(response.companies)) {
        // Cas 3: response.companies est un tableau
        companiesData = response.companies;
      } else if (response && response.success && Array.isArray(response.data)) {
        // Cas 4: {success: true, data: [...]}
        companiesData = response.data;
      }
      
      console.log('Entreprises chargées:', companiesData); // 🆕 DEBUG
      setCompanies(companiesData);
    } catch (error) {
      console.error('Erreur chargement entreprises:', error);
      setCompanies([]); // 🆕 Toujours définir un tableau vide
    }
  };
  
  loadCompanies();
}, []);




  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Préparer les données pour l'envoi
    const dataToSend = {
      ...formData,
      conditions: formData.conditions.split('\n').filter(line => line.trim() !== ''),
      usageInstructions: formData.usageInstructions.split('\n').filter(line => line.trim() !== ''),
      startDate: new Date(formData.startDate).toISOString(),
      endDate: new Date(formData.endDate).toISOString(),
      totalCoupons: parseInt(formData.totalCoupons) || 0,
      redirectUrl: formData.redirectUrl || null,
      employerContribution: parseInt(formData.employerContribution) || 0,
      maxAmount: formData.maxAmount ? parseFloat(formData.maxAmount) : null,
      maxDuration: formData.maxDuration ? parseInt(formData.maxDuration) : null
    };
    
    onSave(dataToSend, isEditing ? offer._id : null);
  };

  const safePartners = Array.isArray(partners) ? partners : [];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content large-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{isEditing ? '✏️ Modifier l\'offre' : '🎯 Créer une nouvelle offre'}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit} className="offer-form">
          <div className="modal-body form-body">
            
            <div className="form-section">
              <h3>Informations principales</h3>
              <div className="form-row">
                <div className="form-group">
                  <label>Titre de l'offre *</label>
                  <input
                    type="text"
                    value={formData.title}
                    onChange={(e) => setFormData({...formData, title: e.target.value})}
                    required
                    placeholder="Titre de l'offre..."
                  />
                </div>
                
                <div className="form-group">
                  <label>Code offre *</label>
                  <input
                    type="text"
                    value={formData.codeOffre}
                    onChange={(e) => setFormData({...formData, codeOffre: e.target.value})}
                    required
                    placeholder="Ex: AVANTAGEA-AIR-25-01"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Description *</label>
                <textarea
                  value={formData.description}
                  onChange={(e) => setFormData({...formData, description: e.target.value})}
                  required
                  placeholder="Description détaillée de l'offre..."
                  rows="3"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Catégorie *</label>
                  <select
                    value={formData.category}
                    onChange={(e) => setFormData({...formData, category: e.target.value})}
                    required
                  >
                    {OFFER_CATEGORIES.map(cat => (
                      <option key={cat.id} value={cat.id}>
                        {cat.icon} {cat.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Type d'offre *</label>
                  <select
                    value={formData.type}
                    onChange={(e) => setFormData({...formData, type: e.target.value})}
                    required
                  >
                    {OFFER_TYPES.map(type => (
                      <option key={type.id} value={type.id}>
                        {type.icon} {type.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Avantage proposé *</label>
                <input
                  type="text"
                  value={formData.discount}
                  onChange={(e) => setFormData({...formData, discount: e.target.value})}
                  required
                  placeholder="Ex: 25% de réduction, Accès gratuit..."
                />
              </div>
            </div>

            <div className="form-section">
              <h3>Partenaire et dates</h3>
              <div className="form-group">
                <label>Assigner à une entreprise partenaire</label>
                <select
                  value={formData.partnerId}
                  onChange={(e) => {
                    const selectedPartner = safePartners.find(p => p._id === e.target.value);
                    setFormData({
                      ...formData,
                      partnerId: e.target.value,
                      partnerName: selectedPartner ? selectedPartner.name : ''
                    });
                  }}
                  required
                >
                  <option value="">Sélectionner un partenaire</option>
                  {safePartners.map(partner => (
                    <option key={partner._id} value={partner._id}>
                      📋 {partner.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Date de début *</label>
                  <input
                    type="date"
                    value={formData.startDate}
                    onChange={(e) => setFormData({...formData, startDate: e.target.value})}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Date de fin *</label>
                  <input
                    type="date"
                    value={formData.endDate}
                    onChange={(e) => setFormData({...formData, endDate: e.target.value})}
                    required
                  />
                </div>
              </div>
            </div>

            <div className="form-group">
              <label>URL de redirection (optionnel)</label>
              <input
                type="text"
                value={formData.redirectUrl}
                onChange={(e) => setFormData({...formData, redirectUrl: e.target.value})}
                placeholder="https://exemple.com/offre-speciale"
              />
              <small style={{color: '#666', fontSize: '12px'}}>
                Si renseigné, l'utilisateur sera redirigé vers cette URL au lieu d'utiliser l'offre normalement.
              </small>
            </div>


            <div className="form-section">
              <h3>Configuration</h3>
              <div className="form-row">
                <div className="form-group checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      checked={formData.isExclusive}
                      onChange={(e) => setFormData({...formData, isExclusive: e.target.checked})}
                    />
                    Offre exclusive
                  </label>
                </div>



                <div className="form-group checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      checked={formData.isEmployeeExclusive}
                      onChange={(e) => {
                        const isEmployeeExclusive = e.target.checked;
                        setFormData({
                          ...formData,
                          isEmployeeExclusive,
                          // Si active employeeExclusive, active automatiquement isExclusive
                          isExclusive: isEmployeeExclusive ? true : formData.isExclusive
                        });
                      }}
                      disabled={!formData.isExclusive} // 🆕 DÉSACTIVÉ SI PAS EXCLUSIVE
                    />
                    Exclusivité par employé
                    {!formData.isExclusive && (
                      <small style={{display: 'block', color: '#666', fontSize: '12px', marginTop: '4px'}}>
                        (Disponible seulement pour les offres exclusives)
                      </small>
                    )}
                  </label>
                </div>




                <div className="form-group checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      checked={formData.hasCoupons}
                      onChange={(e) => setFormData({...formData, hasCoupons: e.target.checked})}
                    />
                    Système de coupons
                  </label>
                </div>

                <div className="form-group checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      checked={formData.isActive}
                      onChange={(e) => setFormData({...formData, isActive: e.target.checked})}
                    />
                    Offre active
                  </label>
                </div>
              </div>

                            {formData.isExclusive && (
                <>
                 {/* 🆕 REMPLACER LE CHAMP TEXTE PAR UN SELECT MULTIPLE */}
      <div className="form-group">
        <label>Sélectionner les entreprises autorisées *</label>
        <select
  multiple
  value={formData.forCompanies}
  onChange={(e) => {
    const selectedOptions = Array.from(e.target.selectedOptions).map(option => option.value);
    setFormData({...formData, forCompanies: selectedOptions});
  }}
  size="4"
  style={{width: '100%', padding: '8px', borderRadius: '4px'}}
  required={formData.isExclusive}
>
  <option value="" disabled>Sélectionnez une ou plusieurs entreprises</option>
  {Array.isArray(companies) && companies.length > 0 ? (
    companies.map(company => (
      <option key={company._id} value={company._id}>
        🏢 {company.name} ({company._id})
      </option>
    ))
  ) : (
    <option disabled>Aucune entreprise disponible</option>
  )}
</select>

        <small style={{color: '#666', fontSize: '12px', marginTop: '4px'}}>
          Maintenez Ctrl (Cmd sur Mac) pour sélectionner plusieurs entreprises
        </small>
        
        {/* Afficher les entreprises sélectionnées */}
        {formData.forCompanies.length > 0 && (
          <div style={{marginTop: '10px'}}>
            <strong>Entreprises sélectionnées ({formData.forCompanies.length}):</strong>
            <div style={{display: 'flex', flexWrap: 'wrap', gap: '5px', marginTop: '5px'}}>
              {formData.forCompanies.map(companyId => {
                const company = companies.find(c => c._id === companyId);
                return (
                  <span 
                    key={companyId} 
                    style={{
                      background: '#e0e7ff',
                      padding: '4px 8px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px'
                    }}
                  >
                    {company?.name || companyId}
                    <button 
                      type="button"
                      onClick={() => {
                        setFormData({
                          ...formData, 
                          forCompanies: formData.forCompanies.filter(id => id !== companyId)
                        });
                      }}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#666',
                        cursor: 'pointer',
                        fontSize: '14px'
                      }}
                    >
                      ✕
                    </button>
                  </span>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* 🆕 SECTION EMPLOYÉS SPÉCIFIQUES AVEC SELECT */}
      {formData.isEmployeeExclusive && (
        <div className="form-group">
          <label>Sélectionner les employés spécifiques</label>
          
          {/* Sélecteur d'entreprise pour filtrer les employés */}
          <div className="form-row">
            <div className="form-group">
              <label>Filtrer par entreprise:</label>
              <select
                value={selectedCompanyId}
                onChange={(e) => setSelectedCompanyId(e.target.value)}
                style={{width: '100%', padding: '8px', borderRadius: '4px'}}
              >
                <option value="">Toutes les entreprises</option>
                {companies.map(company => (
                  <option key={company._id} value={company._id}>
                    🏢 {company.name}
                  </option>
                ))}
              </select>
            </div>
            
            <div className="form-group">
              <label>Sélectionner un employé:</label>
              <select
                value={selectedEmployeeId}
                onChange={(e) => setSelectedEmployeeId(e.target.value)}
                style={{width: '100%', padding: '8px', borderRadius: '4px'}}
                disabled={loadingEmployees}
              >
                <option value="">Choisir un employé</option>
                {loadingEmployees ? (
                  <option disabled>Chargement...</option>
                ) : (
                  employees.map(employee => (
                    <option key={employee._id} value={employee._id}>
                      👤 {employee.firstName} {employee.lastName} ({employee.employeeId || employee._id})
                    </option>
                  ))
                )}
              </select>
              <button
                type="button"
                onClick={() => {
                  if (selectedEmployeeId && !formData.forEmployees.includes(selectedEmployeeId)) {
                    setFormData({
                      ...formData,
                      forEmployees: [...formData.forEmployees, selectedEmployeeId]
                    });
                    setSelectedEmployeeId('');
                  }
                }}
                style={{
                  marginTop: '5px',
                  padding: '6px 12px',
                  background: '#4f46e5',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                ➕ Ajouter cet employé
              </button>
            </div>
          </div>
          
          {/* Afficher les employés sélectionnés */}
          {formData.forEmployees.length > 0 && (
            <div style={{marginTop: '10px'}}>
              <strong>Employés sélectionnés ({formData.forEmployees.length}):</strong>
              <div style={{display: 'flex', flexWrap: 'wrap', gap: '5px', marginTop: '5px'}}>
                {formData.forEmployees.map(employeeId => {
                  // Trouver l'employé dans la liste complète
                  const employee = employees.find(e => e._id === employeeId);
                  return (
                    <span 
                      key={employeeId} 
                      style={{
                        background: '#d1fae5',
                        padding: '4px 8px',
                        borderRadius: '12px',
                        fontSize: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}
                    >
                      {employee ? `👤 ${employee.firstName} ${employee.lastName}` : `ID: ${employeeId}`}
                      <button 
                        type="button"
                        onClick={() => {
                          setFormData({
                            ...formData, 
                            forEmployees: formData.forEmployees.filter(id => id !== employeeId)
                          });
                        }}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#666',
                          cursor: 'pointer',
                          fontSize: '14px'
                        }}
                      >
                        ✕
                      </button>
                    </span>
                  );
                })}
              </div>
            </div>
          )}
          
          <small style={{color: '#666', fontSize: '12px', marginTop: '4px'}}>
            Seulement ces employés spécifiques pourront voir l'offre
          </small>
        </div>
      )}
    </>
  )}

            

              {formData.hasCoupons && (
                <div className="form-group">
                  <label>Nombre de coupons</label>
                  <input
                    type="number"
                    min="0"
                    value={formData.totalCoupons}
                    onChange={(e) => setFormData({...formData, totalCoupons: e.target.value})}
                  />
                </div>
              )}

              <div className="form-row">
                <div className="form-group">
                  <label>Contribution employeur (%)</label>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    value={formData.employerContribution}
                    onChange={(e) => setFormData({...formData, employerContribution: e.target.value})}
                  />
                </div>

                <div className="form-group">
                  <label>Montant maximum (DA)</label>
                  <input
                    type="number"
                    min="0"
                    value={formData.maxAmount}
                    onChange={(e) => setFormData({...formData, maxAmount: e.target.value})}
                    placeholder="Optionnel"
                  />
                </div>

                <div className="form-group">
                  <label>Durée maximum (mois)</label>
                  <input
                    type="number"
                    min="0"
                    value={formData.maxDuration}
                    onChange={(e) => setFormData({...formData, maxDuration: e.target.value})}
                    placeholder="Optionnel"
                  />
                </div>
              </div>
            </div>

            <div className="form-section">
              <h3>Contenu</h3>
              <div className="form-group">
                <label>Conditions d'utilisation (une par ligne)</label>
                <textarea
                  value={formData.conditions}
                  onChange={(e) => setFormData({...formData, conditions: e.target.value})}
                  placeholder="Condition 1&#10;Condition 2&#10;Condition 3"
                  rows="4"
                />
              </div>

              <div className="form-group">
                <label>Instructions d'utilisation (une par ligne)</label>
                <textarea
                  value={formData.usageInstructions}
                  onChange={(e) => setFormData({...formData, usageInstructions: e.target.value})}
                  placeholder="Instruction 1&#10;Instruction 2&#10;Instruction 3"
                  rows="4"
                />
              </div>

              <div className="form-group checkbox-group">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.hasAddress}
                    onChange={(e) => setFormData({...formData, hasAddress: e.target.checked})}
                  />
                  Cette offre a une adresse spécifique
                </label>
              </div>

              {formData.hasAddress && (
                <>
                  <div className="form-group">
                    <label>Adresse</label>
                    <input
                      type="text"
                      value={formData.address}
                      onChange={(e) => setFormData({...formData, address: e.target.value})}
                      placeholder="Adresse complète..."
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Coordonnées GPS (format: geo:lat,lon)</label>
                    <input
                      type="text"
                      value={formData.geolocalisation}
                      onChange={(e) => setFormData({...formData, geolocalisation: e.target.value})}
                      placeholder="geo:36.6919,3.2154"
                    />
                  </div>
                </>
              )}





<div className="form-group">
  <label>URL de redirection (optionnel)</label>
  <input
    type="text"
    value={formData.redirectUrl}
    onChange={(e) => setFormData({...formData, redirectUrl: e.target.value})}
    placeholder="https://exemple.com/offre-speciale"
  />
  <small style={{color: '#666', fontSize: '12px'}}>
    Si renseigné, l'utilisateur sera redirigé vers cette URL au lieu d'utiliser l'offre normalement.
  </small>
</div>


              <div className="form-group">
                <label>URL de l'image</label>
                <input
                  type="text"
                  value={formData.imageUrl}
                  onChange={(e) => setFormData({...formData, imageUrl: e.target.value})}
                  placeholder="https://exemple.com/image.jpg"
                />
                {formData.imageUrl && (
                  <div className="image-preview">
                    <img 
                      src={formData.imageUrl} 
                      alt="Aperçu" 
                      style={{maxWidth: '100px', maxHeight: '100px', borderRadius: '4px', marginTop: '10px'}}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="modal-footer form-footer">
            <Button type="button" variant="secondary" onClick={onClose}>
              Annuler
            </Button>
            <Button type="submit" variant="primary">
              {isEditing ? '💾 Enregistrer les modifications' : '🎯 Créer l\'offre'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

// ==================== COMPOSANT PRINCIPAL ====================

const Offers = () => {
  // États existants
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedOfferType, setSelectedOfferType] = useState('all');
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [selectedCoupons, setSelectedCoupons] = useState(null);
  const [employeeExclusiveFilter, setEmployeeExclusiveFilter] = useState('all'); // 'all', 'employee
  
  // 🆕 États ajoutés pour la gestion CRUD
  const [showOfferForm, setShowOfferForm] = useState(false);
  const [editingOffer, setEditingOffer] = useState(null);
  const [partners, setPartners] = useState([]);

   // 🆕 NOUVEAUX ÉTATS POUR LES FILTRES
  const [activeFilter, setActiveFilter] = useState('all'); // 'all', 'active', 'inactive'
  const [exclusiveFilter, setExclusiveFilter] = useState('all'); // 'all', 'exclusive', 'non-exclusive'
  const [partnerFilter, setPartnerFilter] = useState('all'); // 'all' ou partnerId

  // Charger les offres
  const fetchOffers = async () => {
  try {
    setLoading(true);
    setError('');
    const data = await offerService.getAdminOffers({
      category: selectedCategory !== 'all' ? selectedCategory : null,
      type: selectedOfferType !== 'all' ? selectedOfferType : null,
      // 🆕 AJOUTER LES NOUVEAUX FILTRES
      isActive: activeFilter !== 'all' ? (activeFilter === 'active') : null,
      isExclusive: exclusiveFilter !== 'all' ? (exclusiveFilter === 'exclusive') : null,
      isEmployeeExclusive: employeeExclusiveFilter !== 'all' ? (employeeExclusiveFilter === 'employee-exclusive') : null, // 🆕 NOUVEAU FILTRE
      partnerId: partnerFilter !== 'all' ? partnerFilter : null
    });
    setOffers(data || []);
  } catch (err) {
    setError(err.message || 'Erreur lors du chargement des offres');
    console.error('Erreur fetch offers:', err);
  } finally {
    setLoading(false);
  }
};

  // 🆕 Charger les partenaires
  const fetchPartners = async () => {
    try {
      const response = await companyService.getCompanies();
      
      if (response && Array.isArray(response)) {
        setPartners(response);
      } else if (response && response.data && Array.isArray(response.data)) {
        setPartners(response.data);
      } else if (response && Array.isArray(response.companies)) {
        setPartners(response.companies);
      } else {
        console.warn('Format de réponse non supporté:', response);
        setPartners([]);
      }
    } catch (err) {
      console.error('Erreur chargement partenaires:', err);
      setPartners([]);
    }
  };

  // Chargement initial
  useEffect(() => {
    fetchOffers();
    fetchPartners();
  }, []);

  // Rechargement quand les filtres changent
// Rechargement quand les filtres changent
useEffect(() => {
  fetchOffers();
}, [selectedCategory, selectedOfferType, activeFilter, exclusiveFilter,employeeExclusiveFilter, partnerFilter]); // 🆕 AJOUTER LES NOUVEAUX FILTRES

  // 🆕 Fonctions CRUD ajoutées
  const handleCreateOffer = async (offerData) => {
    try {
      setError('');
      await offerService.createOffer(offerData);
      setShowOfferForm(false);
      await fetchOffers();
      alert('✅ Offre créée avec succès !');
    } catch (err) {
      setError(err.message || 'Erreur lors de la création de l\'offre');
    }
  };

  const handleUpdateOffer = async (offerData, offerId) => {
    try {
      setError('');
      await offerService.updateOffer(offerId, offerData);
      setEditingOffer(null);
      await fetchOffers();
      alert('✅ Offre modifiée avec succès !');
    } catch (err) {
      setError(err.message || 'Erreur lors de la modification de l\'offre');
    }
  };

  const handleDeleteOffer = async (offerId) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer cette offre ?')) {
      return;
    }

    try {
      setError('');
      await offerService.deleteOffer(offerId);
      await fetchOffers();
      alert('✅ Offre supprimée !');
    } catch (err) {
      setError(err.message || 'Erreur lors de la suppression');
    }
  };

  // 🆕 Fonction pour ajouter/changer une image
  const handleAddImage = async (offerId) => {
    try {
      const currentOffer = offers.find(o => o._id === offerId);
      if (!currentOffer) {
        alert('Offre non trouvée');
        return;
      }

      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      
      input.onchange = async (e) => {
        const file = e.target.files[0];
        if (file) {
          try {
            const maxSize = 1024 * 1024;
            if (file.size > maxSize) {
              alert('❌ Fichier trop volumineux. Maximum 1Mo autorisé.');
              return;
            }
            
            const uploadResult = await imagesAPI.uploadImage(file, offerId);
            console.error('reesss:', uploadResult);
            if (uploadResult.success) {
              const updatedOffer = {
                ...currentOffer,
                imageUrl: uploadResult.url
              };
              
              await offerService.updateOffer(offerId, updatedOffer);
              await fetchOffers();
              alert('✅ Photo ajoutée avec succès !');
            }
          } catch (error) {
            console.error('Erreur ajout photo:', error);
            alert('❌ Erreur lors de l\'ajout de la photo: ' + error.message);
          }
        }
      };
      
      input.click();
    } catch (error) {
      console.error('Erreur sélection image:', error);
      alert('Erreur lors de la sélection de l\'image');
    }
  };

  // 🆕 Fonction pour gérer la sauvegarde du formulaire
  const handleSaveOffer = async (offerData, offerId) => {
    if (offerId) {
      await handleUpdateOffer(offerData, offerId);
    } else {
      await handleCreateOffer(offerData);
    }
  };

  // Fonctions existantes
  const getCategoryInfo = (categoryId) => {
    return OFFER_CATEGORIES.find(cat => cat.id === categoryId) || OFFER_CATEGORIES[0];
  };

  const getTypeInfo = (typeId) => {
    return OFFER_TYPES.find(type => type.id === typeId) || OFFER_TYPES[0];
  };

  const getOfferSystem = (offerType) => {
    return OFFER_SYSTEMS_CONFIG[offerType] || { hasCoupons: false };
  };

  const handleViewCoupons = async (offerId) => {
    try {
      setLoading(true);
      const offer = offers.find(o => o._id === offerId);
      
      if (!offer) {
        setError('Offre non trouvée');
        return;
      }

      const couponsData = await couponService.getAdminCoupons(offerId);
      
      setSelectedCoupons({
        offer: offer,
        coupons: couponsData.data || couponsData || []
      });
      
    } catch (err) {
      setError(err.message || 'Erreur lors de la récupération des coupons');
      console.error('Erreur consultation coupons:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (offerId) => {
    const offer = offers.find(o => o._id === offerId);
    if (offer) {
      setSelectedOffer(offer);
    }
  };

  const handleCloseModal = () => {
    setSelectedOffer(null);
  };

  const handleCloseCouponsModal = () => {
    setSelectedCoupons(null);
  };



  const filteredOffers = offers.filter(offer => {
  const categoryMatch = selectedCategory === 'all' || offer.category === selectedCategory;
  const typeMatch = selectedOfferType === 'all' || offer.type === selectedOfferType;
  
  // 🆕 AJOUTER LES NOUVEAUX FILTRES
  const activeMatch = activeFilter === 'all' || 
    (activeFilter === 'active' && offer.isActive) || 
    (activeFilter === 'inactive' && !offer.isActive);
    
  const exclusiveMatch = exclusiveFilter === 'all' || 
    (exclusiveFilter === 'exclusive' && offer.isExclusive) || 
    (exclusiveFilter === 'non-exclusive' && !offer.isExclusive);
    
  const partnerMatch = partnerFilter === 'all' || offer.partnerId === partnerFilter;
  const employeeExclusiveMatch = employeeExclusiveFilter === 'all' || 
      (employeeExclusiveFilter === 'employee-exclusive' && offer.isEmployeeExclusive) || 
      (employeeExclusiveFilter === 'non-employee-exclusive' && !offer.isEmployeeExclusive);

  return categoryMatch && typeMatch && activeMatch && exclusiveMatch && partnerMatch && employeeExclusiveMatch;
});



  if (loading) {
    return (
      <div className="offers">
        <div className="page-header">
          <div className="page-title">
            <h1>Gestion des Offres</h1>
            <p>Chargement...</p>
          </div>
        </div>
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Chargement des offres...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="offers">
      {/* En-tête de page avec bouton AJOUTÉ */}
      <div className="page-header">
        <div className="page-title">
          <h1>Gestion des Offres</h1>
          <p>Consultez et gérez les offres accessibles à vos employés</p>
        </div>
        
        <div className="header-actions">
          <div className="filters">
            <select 
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className="filter-select"
            >
              <option value="all">Toutes les catégories</option>
              {OFFER_CATEGORIES.map(category => (
                <option key={category.id} value={category.id}>
                  {category.icon} {category.name}
                </option>
              ))}
            </select>

            <select 
              value={selectedOfferType}
              onChange={(e) => setSelectedOfferType(e.target.value)}
              className="filter-select"
            >
              <option value="all">Tous les types</option>
              {OFFER_TYPES.map(type => (
                <option key={type.id} value={type.id}>
                  {type.icon} {type.name}
                </option>
              ))}
            </select>




    {/* 🆕 FILTRE STATUT ACTIF/INACTIF */}
    <select 
      value={activeFilter}
      onChange={(e) => setActiveFilter(e.target.value)}
      className="filter-select"
    >
      <option value="all">Tous les statuts</option>
      <option value="active">🟢 Actives</option>
      <option value="inactive">🔴 Inactives</option>
    </select>

    {/* 🆕 FILTRE EXCLUSIF/NON-EXCLUSIF */}
    <select 
      value={exclusiveFilter}
      onChange={(e) => setExclusiveFilter(e.target.value)}
      className="filter-select"
    >
      <option value="all">Toutes offres</option>
      <option value="exclusive">👑 Exclusives</option>
      <option value="non-exclusive">🌍 Non-exclusives</option>
    </select>

 {/* 🆕 FILTRE EXCLUSIVITÉ EMPLOYÉ */}
            <select 
              value={employeeExclusiveFilter}
              onChange={(e) => setEmployeeExclusiveFilter(e.target.value)}
              className="filter-select"
            >
              <option value="all">Tous les types</option>
              <option value="employee-exclusive">👤 Par employé</option>
              <option value="non-employee-exclusive">🏢 Par entreprise</option>
            </select>


    {/* 🆕 FILTRE PAR PARTENAIRE */}
    <select 
      value={partnerFilter}
      onChange={(e) => setPartnerFilter(e.target.value)}
      className="filter-select"
    >
      <option value="all">Tous les partenaires</option>
      {Array.isArray(partners) && partners.map(partner => (
        <option key={partner._id} value={partner._id}>
          📋 {partner.name}
        </option>
      ))}
    </select>

            {/* 🆕 Bouton pour créer une offre */}
            <Button 
              variant="primary" 
              onClick={() => setShowOfferForm(true)}
              className="create-offer-btn"
            >
              🎯 Nouvelle offre
            </Button>



            <Button 
  variant="secondary" 
  onClick={() => {
    setSelectedCategory('all');
    setSelectedOfferType('all');
    setActiveFilter('all');
    setExclusiveFilter('all');
    setPartnerFilter('all');
  }}
  className="reset-filters-btn"
>
  🔄 Réinitialiser
</Button>

          </div>
        </div>
      </div>

      {/* Message d'erreur */}
      {error && (
        <Card className="error-card" padding="md">
          <div className="error-message">
            <span>❌</span>
            {error}
            <button onClick={() => setError('')} className="error-close">✕</button>
          </div>
        </Card>
      )}

      {/* Statistiques rapides */}
      <div className="offers-stats">
        <Card className="stat-card" padding="lg">
          <div className="stat-content">
            <div className="stat-icon">📊</div>
            <div className="stat-info">
              <div className="stat-number">{offers.length}</div>
              <div className="stat-label">Total des offres</div>
            </div>
          </div>
        </Card>
        
        <Card className="stat-card" padding="lg">
          <div className="stat-content">
            <div className="stat-icon">✅</div>
            <div className="stat-info">
              <div className="stat-number">
                {offers.filter(o => o.isActive).length}
              </div>
              <div className="stat-label">Offres actives</div>
            </div>
          </div>
        </Card>
        
        <Card className="stat-card" padding="lg">
          <div className="stat-content">
            <div className="stat-icon">👑</div>
            <div className="stat-info">
              <div className="stat-number">
                {offers.filter(o => o.isExclusive).length}
              </div>
              <div className="stat-label">Offres exclusives</div>
            </div>
          </div>
        </Card>

<Card className="stat-card" padding="lg">
          <div className="stat-content">
            <div className="stat-icon">👤</div>
            <div className="stat-info">
              <div className="stat-number">
                {offers.filter(o => o.isEmployeeExclusive).length}
              </div>
              <div className="stat-label">Par employé</div>
            </div>
          </div>
        </Card>
        <Card className="stat-card" padding="lg">
          <div className="stat-content">
            <div className="stat-icon">🎫</div>
            <div className="stat-info">
              <div className="stat-number">
                {offers.filter(o => o.hasCoupons).length}
              </div>
              <div className="stat-label">Avec coupons</div>
            </div>
          </div>
        </Card>
      </div>

      {/* Grille des offres avec boutons AJOUTÉS */}
      <div className="offers-grid">
        {filteredOffers.map(offer => {
          const categoryInfo = getCategoryInfo(offer.category);
          const typeInfo = getTypeInfo(offer.type);
          const offerSystem = getOfferSystem(offer.type);
          const hasCoupons = offerSystem.hasCoupons && offer.hasCoupons && offer.totalCoupons > 0;
          
          return (
            <Card key={offer._id} className="offer-card" padding="lg">
              {/* Image de l'offre si disponible */}
              {offer.imageUrl && (
                <div className="offer-image-preview">
                  <img src={offer.imageUrl} alt={offer.title} className="offer-image" />
                </div>
              )}
              
              {/* En-tête de l'offre */}
              <div className="offer-header">
                <div className="offer-category">
                  <span className="category-icon">{categoryInfo.icon}</span>
                  <span className="category-name">{categoryInfo.name}</span>
                </div>
                <div className="offer-badges">
                  {offer.isExclusive && (
                    <>
                      <span className="exclusive-badge">
                        {offer.isEmployeeExclusive ? '👤 Par employé' : '🏢 Par entreprise'}
                      </span>
                    </>
                  )}


                  {!offer.isActive && (
                    <span className="inactive-badge">🔴 Inactive</span>
                  )}
                </div>
              </div>

              {/* Titre et code */}
              <div className="offer-title-section">
                <h3 className="offer-title">{offer.title}</h3>
                <div className="offer-code">{offer.codeOffre}</div>
              </div>

              {/* Description courte */}
              <p className="offer-description">
                {offer.description.length > 120 
                  ? `${offer.description.substring(0, 120)}...` 
                  : offer.description
                }
              </p>

              {/* Type et avantage principal */}
              <div className="offer-type-section">
                <span 
                  className="type-badge" 
                  style={{ 
                    backgroundColor: typeInfo.color,
                    color: 'white'
                  }}
                >
                  {typeInfo.icon} {typeInfo.name}
                </span>
                <span className="discount-badge type-primary">
                  {offer.discount}
                </span>
              </div>


              {offer.redirectUrl && (
  <div className="essential-row">
    <span className="essential-label">🔗 Lien:</span>
    <span className="essential-value">Oui</span>
  </div>
)}



              {/* Informations essentielles */}
              <div className="offer-essentials">
                <div className="essential-row">
                  <span className="essential-label">Partenaire:</span>
                  <span className="essential-value">{offer.partnerName}</span>
                </div>
                
                <div className="essential-row">
                  <span className="essential-label">Dates:</span>
                  <span className="essential-value">
                    {new Date(offer.startDate).toLocaleDateString('fr-FR')} - {new Date(offer.endDate).toLocaleDateString('fr-FR')}
                  </span>
                </div>
                
                {offer.hasCoupons && (
                  <div className="essential-row">
                    <span className="essential-label">Coupons:</span>
                    <span className="essential-value">
                      {offer.totalCoupons} total
                    </span>
                  </div>
                )}
              </div>

              {/* ✅ Section COUPONS */}
              {hasCoupons && (
                <div className="offer-usage">
                  <div className="usage-info">
                    <span className="available-coupons">
                      {offer.totalCoupons} coupons générés
                    </span>
                  </div>
                </div>
              )}

              {/* ✅ ACTIONS ADMIN - AVEC BOUTONS AJOUTÉS */}
              <div className="offer-actions">
                <div className="action-buttons">
                  {/* Bouton Voir détails */}
                  <Button 
                    variant="secondary" 
                    size="sm"
                    onClick={() => handleViewDetails(offer._id)}
                  >
                    👁️ Détails
                  </Button>
                  
                  {/* 🆕 Bouton Modifier */}
                  <Button 
                    variant="primary" 
                    size="sm"
                    onClick={() => setEditingOffer(offer)}
                  >
                    ✏️ Modifier
                  </Button>
                  
                  {/* 🆕 Bouton Image */}
                  <Button 
                    variant="mint" 
                    size="sm"
                    onClick={() => handleAddImage(offer._id)}
                  >
                    {offer.imageUrl ? '🖼️ Photo' : '➕ Photo'}
                  </Button>
                  
                  {/* 🆕 Bouton Supprimer */}
                  <Button 
                    variant="danger" 
                    size="sm"
                    onClick={() => handleDeleteOffer(offer._id)}
                  >
                    🗑️ Supprimer
                  </Button>
                </div>
                
                {/* Bouton Voir coupons (si applicable) */}
                {hasCoupons && (
                  <div className="coupon-action">
                    <Button 
                      variant="mint" 
                      size="sm"
                      onClick={() => handleViewCoupons(offer._id)}
                    >
                      🎫 Voir coupons
                    </Button>
                  </div>
                )}
              </div>
            </Card>
          );
        })}
      </div>

      {/* État vide */}
      {filteredOffers.length === 0 && !loading && (
        <Card className="empty-state">
          <div className="empty-icon">🔍</div>
          <h3 className="empty-title">Aucune offre trouvée</h3>
          <p className="empty-text">
            {offers.length === 0 
              ? "Aucune offre disponible pour le moment"
              : "Aucune offre ne correspond aux filtres sélectionnés"
            }
          </p>
          <div className="empty-actions">
            <Button 
              variant="primary"
              onClick={() => {
                setSelectedCategory('all');
                setSelectedOfferType('all');
              }}
            >
              📋 Voir toutes les offres
            </Button>
            <Button 
              variant="secondary"
              onClick={() => setShowOfferForm(true)}
            >
              🎯 Créer une offre
            </Button>
          </div>
        </Card>
      )}

      {/* ==================== MODALS ==================== */}
      
      {/* Modal des détails (EXISTANT) */}
      {selectedOffer && (
        <OfferDetailsModal 
          offer={selectedOffer} 
          onClose={handleCloseModal} 
        />
      )}

      {/* Modal des coupons (EXISTANT) */}
      {selectedCoupons && (
        <CouponsModal 
          offer={selectedCoupons.offer}
          coupons={selectedCoupons.coupons}
          onClose={handleCloseCouponsModal}
        />
      )}

      {/* 🆕 Modal création/modification d'offre */}
      {showOfferForm && (
        <OfferFormModal
          offer={null}
          partners={partners}
          onSave={handleSaveOffer}
          onClose={() => setShowOfferForm(false)}
        />
      )}


      {/* 🆕 Modal modification d'offre existante */}
      {editingOffer && (
        <OfferFormModal
          offer={editingOffer}
          partners={partners}
          onSave={handleSaveOffer}
          onClose={() => setEditingOffer(null)}
        />
      )}
    </div>
  );
};

export default Offers;